import React, { useState, useEffect } from "react";
// import api from "../../../../Axios/api";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import api from "../../../Axios/api";
import MaterialTable from "material-table";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import { Link } from "react-router-dom";
import pal from "../../../themes/palette";
import RemoveProfilePic from "../../../Components/FormDialog/RemoveProfilePic";
import ImageCropProfile from "../../../Components/FormDialog/ImageCropProfile";
import AddAPhotoIcon from "@material-ui/icons/AddAPhoto";
import InputLabel from "@material-ui/core/InputLabel";

import {
  Select,
  MenuItem,
  Modal,
  Button,
  TextField,
  Container,
  Grid,
  Paper,
  Avatar,
  Typography,
} from "@material-ui/core";
import noImage from "../../../assets/images/Product Images/noImage.png";
import LibraryAddIcon from "@material-ui/icons/LibraryAdd";
import { Redirect } from "react-router-dom";
import { useUserContext } from "../../../context/UserContext";
import useStyles from "./styles";

export default function ReportProblem() {
  // Snackbar
  const [snackBarstate, setSnackBar] = useState({
    open: false,
    vertical: "top",
    horizontal: "right",
    type: "success",
    message: "",
  });
  const { vertical, horizontal, open } = snackBarstate;
  const handleCloseSnackBar = () => {
    setSnackBar({ ...snackBarstate, open: false });
  };

  const classes = useStyles();
  // context
  const { store } = useUserContext();
  const token = store.data.token;

  const [isLoggedOut, setIsLoggedOut] = useState(false);
  // Modal Settings here
  const [modalOpen, setModelOpen] = useState(false);

  const handleOpen = () => {
    setModelOpen(true);
  };

  const handleClose = () => {
    setModelOpen(false);
  };

  const [details, setDetails] = useState([]);
  const [complaintDetails, setComplaintDetails] = useState({
    subject: "",
    description: "",
    screenShot: "",
  });

  const handleComplaintDetails = (input) => (e) => {
    setComplaintDetails({ ...complaintDetails, [input]: e.target.value });
  };

  const [isProfilePicRemove, setIsProfilePicRemove] = useState(false);

  const onSelectlogo = (image) => {
    setComplaintDetails({ ...complaintDetails, screenShot: image });
  };

  // Show delete ProfilePic dialog
  const handlerRemoveProfilePic = (e) => {
    e.preventDefault();
    setIsProfilePicRemove(true);
  };

  const confirmedRemoveProfilePic = () => {
    setComplaintDetails({ ...complaintDetails, screenShot: "" });
    setIsProfilePicRemove(false);
  };
  const [IFerrors, setIFerrors] = useState({
    subjectError: "",
    descriptionError: "",
  });

  const InputValidation = () => {
    const errors = {};
    var hasError = false;

    // Vendor name list
    if (complaintDetails.subject.length === 0) {
      hasError = true;
      errors.subjectError = "Please Choose subject!";
    } else {
      errors.subjectError = "";
    }

    setIFerrors({ ...IFerrors, ...errors });
    return hasError;
  };
  const columns = [
    {
      title: "ID",
      field: "tableData.id",
      render: ({ tableData }) => <div>{tableData.id + 1}</div>,
      hidden: false,
      export: false,
    },
    {
      title: "Subject",
      field: "subject",
    },
    {
      title: "Description",
      field: "description",
    },
    {
      title: "Screen Shot",
      field: "screenShot",
      render: ({ screenShot }) => (
        <img
          src={screenShot ? screenShot : noImage}
          alt="profilepic"
          style={{ width: 40, height: 40, borderRadius: "50%" }}
        />
      ),
    },
  ];

  const reportProblem = (e) => {
    e.preventDefault();
    if (!complaintDetails.screenShot) {
      delete complaintDetails.screenShot;
    }
    // console.log('report', complaintDetails)
    api
      .post(
        "/buyer/reportProblem",
        {
          ...complaintDetails,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then((res) => {
        setDetails([...details, res.data.data.problem]);
        setSnackBar({
          ...snackBarstate,
          type: "success",
          message: "Problem Successfully Reported!",
          open: true,
        });
        console.log(res.data.data.problem);
      })
      .catch((error) =>
        setSnackBar({
          ...snackBarstate,
          type: "error",
          message: "ERROR: Something went wrong!",
          open: true,
        })
      );
  };

  const retrivingAllComplaints = async () => {
    await api
      .get("/buyer/view/reported/problems", {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        setDetails(res.data.data.problems);
      })
      .catch((error) =>
        console.log("ERROR: " + JSON.stringify(error.response.data.error))
      );
  };

  useEffect(() => {
    //scroll to the top of page
    window.scrollTo(0, 0);
    // Retriving List of Products from API
    retrivingAllComplaints();
  }, []);

  return (
    <Grid container className={classes.root}>
      <Snackbar
        open={open}
        anchorOrigin={{ vertical, horizontal }}
        autoHideDuration={3000}
        onClose={handleCloseSnackBar}
        key={vertical + horizontal}
      >
        <MuiAlert
          elevation={6}
          variant="filled"
          onClose={handleCloseSnackBar}
          severity={snackBarstate.type}
        >
          {snackBarstate.message}
        </MuiAlert>
      </Snackbar>
      <Breadcrumbs
        style={{ paddingTop: 30, paddingBottom: 15 }}
        aria-label="breadcrumb"
      >
        <Link className={classes.bCrumbLink} style={{ color: "grey" }} to="/">
          Home
        </Link>
        <Link
          className={classes.bCrumbLink}
          style={{ color: "grey" }}
          to="/account"
        >
          My Account
        </Link>
        <Typography color="textPrimary">Report Problem</Typography>
      </Breadcrumbs>

      {isLoggedOut ? <Redirect to="/admin/login" /> : ""}
      <Grid
        item
        xs={12}
        sm={12}
        md={12}
        style={{
          marginBottom: 20,
          boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 12px",
          paddingBottom: 20,
        }}
      >
        <Container component="div" maxWidth="sm">
          <div className={classes.paper} style={{ marginTop: 10, padding: 15 }}>
            <Avatar className={classes.avatar}>
              <LibraryAddIcon />
            </Avatar>
            <Typography variant="h5">Report Problem </Typography>
            <Grid className={classes.settingsSpacing} style={{ marginTop: 10 }}>
              <form className={classes.form}>
                <InputLabel id="demo-simple-select-outlined-label">
                  Problem Subject
                </InputLabel>
                <Select
                  variant="outlined"
                  margin="dense"
                  required
                  fullWidth
                  value={complaintDetails.subject}
                  label="Problem Subject"
                  style={{ marginTop: 8 }}
                  defaultValue={"Subject"}
                  onChange={handleComplaintDetails("subject")}
                  error={IFerrors.subjectError.length > 0 ? true : false}
                >
                  <MenuItem value="DEFAULT" disabled>
                    Choose Subject
                  </MenuItem>

                  <MenuItem value={"Faulty Product"}>Server Error</MenuItem>
                  <MenuItem value={"Broken Product"}>Order Not Placed</MenuItem>
                  <MenuItem value={"Package already opened"}>
                    Package already opened
                  </MenuItem>
                  <MenuItem value={"Package already opened"}>
                    Order nor Received
                  </MenuItem>
                </Select>
                <InputLabel
                  id="demo-simple-select-outlined-label"
                  style={{ marginTop: 15 }}
                >
                  Problem Description
                </InputLabel>
                <TextField
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  id="description"
                  label="Problem Description"
                  name="description"
                  required
                  onChange={handleComplaintDetails("description")}
                />

                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginTop: 20,
                    marginBottom: 5,
                    padding: 20,
                    height: 160,
                    border: "1px solid #c4c4c4",
                    borderRadius: 6,
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-evenly",
                      alignItems: "center",
                      marginBottom: "20px",
                    }}
                  >
                    {/* <Avatar
                      alt="profile photo"
                      src={complaintDetails.screenShot}
                      className={classes.avatarInProfileSetting}
                    >
                      {"Add +"}
                    </Avatar> */}
                    <div style={{ marginTop: 30, marginLeft: 20 }}>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={handleOpen}
                      >
                        <AddAPhotoIcon
                          style={{
                            marginRight: 5,
                            fontSize: 22,
                            marginBottom: 5,
                          }}
                        />
                        Upload
                      </Button>
                      <Button
                        onClick={handlerRemoveProfilePic}
                        style={{ color: "red" }}
                      >
                        Remove Image
                      </Button>
                    </div>
                  </div>
                </div>
                <Button
                  fullWidth
                  variant="contained"
                  color="primary"
                  type="submit"
                  onClick={reportProblem}
                  className={classes.submit}
                  style={{ width: "100%", marginTop: 15 }}
                >
                  Report Problem
                </Button>
              </form>
            </Grid>
          </div>
        </Container>
        <MaterialTable
        className={classes.tableOfProblems}
          // style={{ width: "100%" }}
          title="Reported Problems"
          data={details}
          columns={columns}
          // actions={[
          //   (rowData) => ({
          //     icon: () => <EditIcon />,
          //     tooltip: "Edit",
          //     onClick: (event, rowData) => {
          //       setBuyerDetails(rowData);
          //       handleOpen();
          //     },
          //   }),
          // ]}
          options={{
            actionsColumnIndex: -1,
            headerStyle: {
              backgroundColor: pal.palette.primary.main,
              color: "#fff",
              whiteSpace: "nowrap",
            },

            // tableLayout: "auto",
            pagination: "false",
          }}
        />
      </Grid>
      <RemoveProfilePic
        RemoveProfilePic={isProfilePicRemove}
        setRemoveProfilePic={setIsProfilePicRemove}
        confirmedRemoveProfilePic={confirmedRemoveProfilePic}
      />

      <Modal
        open={modalOpen}
        onClose={handleClose}
        onBackdropClick={handleClose}
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div
          style={{
            backgroundColor: "#FFF",
            width: "70vw",
            height: "70vh",
            padding: "20px",
            position: "relative",
          }}
        >
          <ImageCropProfile
            onProfileChange={onSelectlogo}
            handleClose={handleClose}
          />
        </div>
      </Modal>
    </Grid>
  );
}
